module.exports = __webpack_public_path__ + "img/v2-redesign-library.a71b209e.png";